export function LocalizationDataGridConst(localization) {
  return {
    noRowsLabel: localization.noRow,
    toolbarDensity: localization.density,
    toolbarColumns: localization.columns,
    toolbarFilters: localization.filter,
    toolbarExport: localization.download,
    columnsPanelTextFieldLabel: localization.findColumn,
    columnsPanelTextFieldPlaceholder: localization.columnTitle,
    columnsPanelDragIconLabel: localization.reorderColumn,
    columnsPanelShowAllButton: localization.showAll,
    columnsPanelHideAllButton: localization.hideAll,
    columnMenuManageColumns: localization.manageColumn,
    columnMenuFilter: localization.filter,
    columnMenuHideColumn: localization.hideColumn,
    columnMenuSortAsc: localization.sortAsc,
    columnMenuSortDesc: localization.sortDesc,
    // Filter panel text
    filterPanelAddFilter: localization.addButton,
    filterPanelRemoveAll: localization.removeAll,
    filterPanelDeleteIconLabel: localization.delete,
    filterPanelLogicOperator: "Logic operator",
    filterPanelOperator: localization.operator,
    filterPanelOperatorAnd: "And",
    filterPanelOperatorOr: "Or",
    filterPanelColumns: localization.columns,
    filterPanelInputLabel: localization.value,
    filterPanelInputPlaceholder: localization.filterValue,
    // Filter operators text
    filterOperatorContains: localization.contains,
    filterOperatorEquals: localization.equalsOperator,
    filterOperatorStartsWith: localization.startwith,
    filterOperatorEndsWith: localization.endWith,
    filterOperatorIs: localization.isOperator,
    filterOperatorNot: localization.isNotOperator,
    filterOperatorAfter: localization.isAfterOperator,
    filterOperatorOnOrAfter: localization.isOnAfterOperator,
    filterOperatorBefore: localization.isBeforeOperator,
    filterOperatorOnOrBefore: localization.isOnBeforeOperator,
    filterOperatorIsEmpty: localization.isEmptyOperator,
    filterOperatorIsNotEmpty: localization.isNotEmptyOperator,
    filterOperatorIsAnyOf: localization.isAnyOfOperator,
    // Density selector toolbar button text
    toolbarDensity: localization.density,
    toolbarDensityLabel: localization.density,
    toolbarDensityCompact: localization.compactTableLabel,
    toolbarDensityStandard: localization.standardTableLabel,
    toolbarDensityComfortable: localization.comfortableTableLabel,
    toolbarExport: localization.download,
    toolbarExportLabel: localization.exportTitle,
    toolbarExportCSV: localization.downloadCsv,
    toolbarExportPrint: localization.Print,
    toolbarExportExcel: localization.downloadExcel,
    toolbarQuickFilterPlaceholder: localization.searchPlaceholder,
    checkboxSelectionHeaderName: localization.columnSelection,
    detailPanelToggle: localization.detailPanelToggle,
  };
}

export const tableFilterProperty = {
  columnsSort: "asc",
  filterFormProps: {
    logicOperators: [],
    logicOperatorInputProps: {
      variant: "outlined",
      size: "small",
    },
    columnInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    operatorInputProps: {
      variant: "outlined",
      size: "small",
      sx: { mt: "auto" },
    },
    valueInputProps: {
      InputComponentProps: {
        variant: "outlined",
        size: "small",
      },
    },
    deleteIconProps: {
      sx: {
        "& .MuiSvgIcon-root": { color: "#d32f2f" },
      },
    },
  },
  sx: {
    // Customize inputs using css selectors
    "& .MuiDataGrid-filterForm": { p: 2 },
    "& .MuiDataGrid-filterForm:nth-child(even)": {
      backgroundColor: (theme) =>
        theme.palette.mode === "dark" ? "#444" : "#f5f5f5",
    },
    "& .MuiDataGrid-filterFormLogicOperatorInput": { mr: 2 },
    "& .MuiDataGrid-filterFormColumnInput": { mr: 2, width: 150 },
    "& .MuiDataGrid-filterFormOperatorInput": { mr: 2 },
    "& .MuiDataGrid-filterFormValueInput": { width: 200 },
  },
};
